import ApiService from '@/services/api.service'

const TypicalUnitService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/TypicalUnits/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    },  

    Add(data){
        return ApiService.post(`/TypicalUnits`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/TypicalUnits/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/TypicalUnits/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/TypicalUnits/${Id}`);
    }
  }


  
  export default TypicalUnitService;